import { createListenerMiddleware } from '@reduxjs/toolkit';
import { searchAttendeesStatsByEvent } from 'src/redesign/features/AttendeeStats/actions';
import { searchAttendeesByEvent } from 'src/redesign/features/Attendees/store/actions';
import { eventsFiltersSlice } from '../../EventsFilters/reducer';

export const listenerMiddleware = createListenerMiddleware();

listenerMiddleware.startListening({
  actionCreator: eventsFiltersSlice.actions.setFiltersData,
  effect: async (_, listenerApi) => {
    const filters = listenerApi.getState()?.eventsFilters?.filtersData;
    const eventId = listenerApi.getState()?.events.currentEvent?.id;
    await listenerApi.dispatch(
      searchAttendeesStatsByEvent({ eventId: eventId, criteria: filters }),
    );
    await listenerApi.dispatch(searchAttendeesByEvent({ eventId: eventId, criteria: filters }));
    // listenerApi.unsubscribe();
  },
});

listenerMiddleware.startListening({
  actionCreator: searchAttendeesStatsByEvent.fulfilled,
  effect: async (_, listenerApi) => {
    const filters = listenerApi.getState()?.eventsFilters?.filtersData;
    const eventId = listenerApi.getState()?.events.currentEvent?.id;
    const { attendees, occurrences, ...cleanedFilters } = filters;
    await listenerApi.dispatch(
      searchAttendeesByEvent({ eventId: eventId, criteria: cleanedFilters }),
    );
    listenerApi.unsubscribe();
  },
});
